import { userUiPreferenceStorage } from "../lib/userUiPreferenceStorage.js";
export const DEFAULT_EVENING_RAIL_RATIO = 0.72 / 2.92;
export const EVENING_RAIL_GAP_PX = 4;
export const MIN_EVENING_RAIL_WIDTH = 160;
export const MIN_DAY_RAIL_WIDTH = 320;

export function resolveEveningRailLayout(ratio, containerWidth) {
  const width = Math.max(0, Number(containerWidth) - EVENING_RAIL_GAP_PX || 0);
  const resizable = width >= MIN_EVENING_RAIL_WIDTH + MIN_DAY_RAIL_WIDTH;
  const preferredRatio = typeof ratio === "number" && Number.isFinite(ratio) && ratio > 0 && ratio < 1
    ? ratio : DEFAULT_EVENING_RAIL_RATIO;
  const resolvedRatio = resizable
    ? Math.min(1 - MIN_DAY_RAIL_WIDTH / width, Math.max(MIN_EVENING_RAIL_WIDTH / width, preferredRatio))
    : DEFAULT_EVENING_RAIL_RATIO;
  return {
    width,
    ratio: resolvedRatio,
    resizable,
    eveningWidth: resolvedRatio * width,
    gridTemplateColumns: `minmax(0,${1 - resolvedRatio}fr) minmax(0,${resolvedRatio}fr)`,
    separatorLeft: `${width * (1 - resolvedRatio) + EVENING_RAIL_GAP_PX / 2}px`,
  };
}

function resolveStorage(storage) {
  try { return storage === undefined ? userUiPreferenceStorage("local") : storage; } catch { return null; }
}

export function eveningRailWidthStorageKey(userId) {
  return typeof userId === "string" && userId.trim()
    ? `grain-saas:results:evening-rail-width:v1:${encodeURIComponent(userId.trim())}` : "";
}

export function readEveningRailWidth(userId, storage = undefined) {
  try {
    const key = eveningRailWidthStorageKey(userId);
    const value = key ? Number(resolveStorage(storage)?.getItem(key)) : NaN;
    return Number.isFinite(value) && value > 0 && value < 1 ? value : DEFAULT_EVENING_RAIL_RATIO;
  } catch { return DEFAULT_EVENING_RAIL_RATIO; }
}

export function persistEveningRailWidth(userId, ratio, storage = undefined) {
  const key = eveningRailWidthStorageKey(userId);
  if (!key || !Number.isFinite(ratio) || ratio <= 0 || ratio >= 1) return;
  try { resolveStorage(storage)?.setItem(key, String(ratio)); } catch { /* Keep the in-memory preference. */ }
}
